// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/images/background-pattern.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* div {
  border: 1px solid black;
} */

.section5_container__dYLl- {
  /*background-image: url(/public/images/outview3.png); */
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); /* 패턴 이미지 경로 */
  background-repeat: repeat;
  background-position: center;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;               /* 자식 div가 공간을 초과하면 자동으로 줄 바꿈 */
  
  padding: 5%;
}

.section5_parent__lAR6S {
  display: flex;                /* Flexbox로 배치 */
  flex-wrap: wrap;               /* 자식 div가 공간을 초과하면 자동으로 줄 바꿈 */
  gap: 10px;                     /* 자식 div들 간의 간격 */
}

/* 자식 div */
.section5_top__1y6Hf {
  text-align: center;           /* 텍스트 중앙 정렬 */  
}


/* 자식 div */
.section5_child__Kel9n {
  flex: 1 1 40%;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */
  border-radius: 100px;          /* 모서리를 둥글게 */
  padding: 5%;                /* 내부 여백 */
  text-align: center;           /* 텍스트 중앙 정렬 */
  box-sizing: border-box;       /* padding, border가 전체 크기에 포함되도록 설정 */
  background-color: #0c78B7;
  outline: 1px solid white;
  outline-offset: -5px;
}

.section5_text-box__AL2yG {
  font-size: 34px;
  color: #FEFFA4;
  font-weight: 1000;
}


.section5_text-small__9i\\+Ff {
  letter-spacing: 5px;
  font-size: 16px;
  color: white;
  margin-bottom: 5px;
}

.section5_text-mid__0uf3o {
  font-size: 22px;
  color: black;
  margin-bottom: 40px;
  margin-left: 20%;
  margin-right: 20%;
}

.section5_text-large__3\\+Jht {
  margin-top: 0;
  font-size: 45px;
  color: #0c78B7;
  font-weight: 1000;
  margin-bottom: 30px;
}


.section5_text-large2__fXVMo {
  font-size: 30px;
  color: white;
  font-weight: 1000;
}

.section5_rounded-box__cGdLl {
  display: flex; /* 플렉스 박스 적용 */
  justify-content: center; /* 가로 중앙 정렬 */
  align-items: center; /* 세로 중앙 정렬 */

  width: 500px;  /* 원하는 크기로 조절 */
  height: 80px; /* 원하는 높이로 조절 */
  border: 2px solid rgba(255, 255, 255, 0.4); /* 테두리를 약간만 보이게 */
  border-radius: 50px; /* 상하 50px 반원 */
}

.section5_modal__teUcb {
  position: fixed;
  
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3); /* 반투명 배경 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.section5_modal-content__G6fVX {
  background: white;
  padding: 10px;
  border-radius: 10px;
  z-index: 1000; /* 이미지 뒤에 깔릴 수 있도록 설정 */
}

.section5_modal-content__G6fVX img {
  border-radius: 10px;
  width: 100%;
  z-index: 1000; /* 이미지 뒤에 깔릴 수 있도록 설정 */
}

/* 투명한 div (오버레이) */
.section5_overlay__\\+TkeX {
  position: fixed;
  top: -40vh;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(255, 0, 0, 0.5); /* 반투명 배경 */
  z-index: 2000; /* 이미지 뒤에 깔릴 수 있도록 설정 */
}


@media (max-width: 767px) {
  .section5_parent__lAR6S {
    gap: 20px;                     /* 자식 div들 간의 간격 */
    width : 100%;
    padding-left: 15%;
    padding-right: 15%;
  }

  .section5_child__Kel9n {
    flex: 2 1 100%;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */
    border-radius: 60px;          /* 모서리를 둥글게 */
  }

  .section5_image-hpt__rYt-Q {
    width : 70px;
  }

  .section5_image-bed__dn2XR {
    width : 70px;

  }
  

  .section5_text-mid__0uf3o {
    font-size: 14px;
  }

  .section5_text-large__3\\+Jht {
    font-size: 40px;
  }

  .section5_text-box__AL2yG {
    font-size: 24px;
  }

}

@media (min-width: 767px) and (max-width: 1286px) {

  .section5_child__Kel9n {
    flex: 30% 1;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */
    
    border-radius: 60px;          /* 모서리를 둥글게 */
  }
  

  .section5_text-large__3\\+Jht {
    font-size: 80px;
  }

  .section5_text-mid__0uf3o {
    margin-bottom: 80px;
  }

  .section5_top__1y6Hf {
    width: 100%;
  }

  .section5_parent__lAR6S {
    width : 100%
  }
  
}

@media (min-width: 1287px) {

  .section5_child__Kel9n {
    flex: 30% 1;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */
    
    border-radius: 60px;          /* 모서리를 둥글게 */
  }
  

  .section5_text-large__3\\+Jht {
    font-size: 80px;
  }

  .section5_text-mid__0uf3o {
    margin-bottom: 80px;
  }

  .section5_top__1y6Hf {
    width: 40%;
  }

  .section5_parent__lAR6S {
    width : 50%
  }
  
}`, "",{"version":3,"sources":["webpack://./src/Sections/section5.module.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;EACE,uDAAuD;EACvD,yDAA8D,EAAE,cAAc;EAC9E,yBAAyB;EACzB,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,eAAe,gBAAgB,+BAA+B;;EAE9D,WAAW;AACb;;AAEA;EACE,aAAa,iBAAiB,gBAAgB;EAC9C,eAAe,gBAAgB,+BAA+B;EAC9D,SAAS,sBAAsB,kBAAkB;AACnD;;AAEA,WAAW;AACX;EACE,kBAAkB,YAAY,cAAc;AAC9C;;;AAGA,WAAW;AACX;EACE,aAAa,iBAAiB,sCAAsC;EACpE,oBAAoB,WAAW,aAAa;EAC5C,WAAW,iBAAiB,UAAU;EACtC,kBAAkB,YAAY,cAAc;EAC5C,sBAAsB,QAAQ,qCAAqC;EACnE,yBAAyB;EACzB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa,EAAE,cAAc;EAC7B,uBAAuB,EAAE,aAAa;EACtC,mBAAmB,EAAE,aAAa;;EAElC,YAAY,GAAG,eAAe;EAC9B,YAAY,EAAE,eAAe;EAC7B,0CAA0C,EAAE,iBAAiB;EAC7D,mBAAmB,EAAE,eAAe;AACtC;;AAEA;EACE,eAAe;;EAEf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,WAAW;EAC3C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,aAAa,EAAE,uBAAuB;AACxC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa,EAAE,uBAAuB;AACxC;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,UAAU;EACV,OAAO;EACP,YAAY;EACZ,aAAa;EACb,gCAAgC,EAAE,WAAW;EAC7C,aAAa,EAAE,uBAAuB;AACxC;;;AAGA;EACE;IACE,SAAS,sBAAsB,kBAAkB;IACjD,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,cAAc,cAAc,sCAAsC;IAClE,mBAAmB,WAAW,aAAa;EAC7C;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;;EAEd;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,WAAS,cAAc,sCAAsC;;IAE7D,mBAAmB,WAAW,aAAa;EAC7C;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE;EACF;;AAEF;;AAEA;;EAEE;IACE,WAAS,cAAc,sCAAsC;;IAE7D,mBAAmB,WAAW,aAAa;EAC7C;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE;EACF;;AAEF","sourcesContent":["/* div {\n  border: 1px solid black;\n} */\n\n.container {\n  /*background-image: url(/public/images/outview3.png); */\n  background-image: url('/public/images/background-pattern.png'); /* 패턴 이미지 경로 */\n  background-repeat: repeat;\n  background-position: center;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;               /* 자식 div가 공간을 초과하면 자동으로 줄 바꿈 */\n  \n  padding: 5%;\n}\n\n.parent {\n  display: flex;                /* Flexbox로 배치 */\n  flex-wrap: wrap;               /* 자식 div가 공간을 초과하면 자동으로 줄 바꿈 */\n  gap: 10px;                     /* 자식 div들 간의 간격 */\n}\n\n/* 자식 div */\n.top {\n  text-align: center;           /* 텍스트 중앙 정렬 */  \n}\n\n\n/* 자식 div */\n.child {\n  flex: 1 1 40%;                /* 크기 설정: 최소 40%에서 시작해 최대 크기까지 확장 가능 */\n  border-radius: 100px;          /* 모서리를 둥글게 */\n  padding: 5%;                /* 내부 여백 */\n  text-align: center;           /* 텍스트 중앙 정렬 */\n  box-sizing: border-box;       /* padding, border가 전체 크기에 포함되도록 설정 */\n  background-color: #0c78B7;\n  outline: 1px solid white;\n  outline-offset: -5px;\n}\n\n.text-box {\n  font-size: 34px;\n  color: #FEFFA4;\n  font-weight: 1000;\n}\n\n\n.text-small {\n  letter-spacing: 5px;\n  font-size: 16px;\n  color: white;\n  margin-bottom: 5px;\n}\n\n.text-mid {\n  font-size: 22px;\n  color: black;\n  margin-bottom: 40px;\n  margin-left: 20%;\n  margin-right: 20%;\n}\n\n.text-large {\n  margin-top: 0;\n  font-size: 45px;\n  color: #0c78B7;\n  font-weight: 1000;\n  margin-bottom: 30px;\n}\n\n\n.text-large2 {\n  font-size: 30px;\n  color: white;\n  font-weight: 1000;\n}\n\n.rounded-box {\n  display: flex; /* 플렉스 박스 적용 */\n  justify-content: center; /* 가로 중앙 정렬 */\n  align-items: center; /* 세로 중앙 정렬 */\n\n  width: 500px;  /* 원하는 크기로 조절 */\n  height: 80px; /* 원하는 높이로 조절 */\n  border: 2px solid rgba(255, 255, 255, 0.4); /* 테두리를 약간만 보이게 */\n  border-radius: 50px; /* 상하 50px 반원 */\n}\n\n.modal {\n  position: fixed;\n  \n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3); /* 반투명 배경 */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: white;\n  padding: 10px;\n  border-radius: 10px;\n  z-index: 1000; /* 이미지 뒤에 깔릴 수 있도록 설정 */\n}\n\n.modal-content img {\n  border-radius: 10px;\n  width: 100%;\n  z-index: 1000; /* 이미지 뒤에 깔릴 수 있도록 설정 */\n}\n\n/* 투명한 div (오버레이) */\n.overlay {\n  position: fixed;\n  top: -40vh;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(255, 0, 0, 0.5); /* 반투명 배경 */\n  z-index: 2000; /* 이미지 뒤에 깔릴 수 있도록 설정 */\n}\n\n\n@media (max-width: 767px) {\n  .parent {\n    gap: 20px;                     /* 자식 div들 간의 간격 */\n    width : 100%;\n    padding-left: 15%;\n    padding-right: 15%;\n  }\n\n  .child {\n    flex: 2 1 100%;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */\n    border-radius: 60px;          /* 모서리를 둥글게 */\n  }\n\n  .image-hpt {\n    width : 70px;\n  }\n\n  .image-bed {\n    width : 70px;\n\n  }\n  \n\n  .text-mid {\n    font-size: 14px;\n  }\n\n  .text-large {\n    font-size: 40px;\n  }\n\n  .text-box {\n    font-size: 24px;\n  }\n\n}\n\n@media (min-width: 767px) and (max-width: 1286px) {\n\n  .child {\n    flex: 30%;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */\n    \n    border-radius: 60px;          /* 모서리를 둥글게 */\n  }\n  \n\n  .text-large {\n    font-size: 80px;\n  }\n\n  .text-mid {\n    margin-bottom: 80px;\n  }\n\n  .top {\n    width: 100%;\n  }\n\n  .parent {\n    width : 100%\n  }\n  \n}\n\n@media (min-width: 1287px) {\n\n  .child {\n    flex: 30%;             /* 화면이 작으면 자식 div가 100% 크기를 차지하도록 설정 */\n    \n    border-radius: 60px;          /* 모서리를 둥글게 */\n  }\n  \n\n  .text-large {\n    font-size: 80px;\n  }\n\n  .text-mid {\n    margin-bottom: 80px;\n  }\n\n  .top {\n    width: 40%;\n  }\n\n  .parent {\n    width : 50%\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `section5_container__dYLl-`,
	"parent": `section5_parent__lAR6S`,
	"top": `section5_top__1y6Hf`,
	"child": `section5_child__Kel9n`,
	"text-box": `section5_text-box__AL2yG`,
	"text-small": `section5_text-small__9i+Ff`,
	"text-mid": `section5_text-mid__0uf3o`,
	"text-large": `section5_text-large__3+Jht`,
	"text-large2": `section5_text-large2__fXVMo`,
	"rounded-box": `section5_rounded-box__cGdLl`,
	"modal": `section5_modal__teUcb`,
	"modal-content": `section5_modal-content__G6fVX`,
	"overlay": `section5_overlay__+TkeX`,
	"image-hpt": `section5_image-hpt__rYt-Q`,
	"image-bed": `section5_image-bed__dn2XR`
};
export default ___CSS_LOADER_EXPORT___;
